import { returnRefAndGenerateDataTracker } from '@/components/atoms/button/utils';
import { Text } from '@/components/atoms/text';
import { WithRef } from '@/components/types';

export type TextAreaProps = WithRef<
  HTMLTextAreaElement,
  {
    children: React.ReactNode;
  } & React.TextareaHTMLAttributes<HTMLTextAreaElement>
>;

export const TextArea = ({ children, ref, ...props }: TextAreaProps) => {
  return (
    <div className='relative'>
      <textarea
        data-tracker-component='additional-info-text-area'
        className='border-neutral-N20 focus:!border-primary-P99 block h-[124px] w-full max-w-[584px] resize-none rounded-[4px] border px-4 py-2 focus:outline-none'
        {...props}
        ref={(_ref) => {
          returnRefAndGenerateDataTracker(_ref, ref);
        }}
      />
      <Text
        variant='body-m'
        classNames={{
          wrapper:
            'absolute bottom-0 right-0 pb-[10px] pr-4 leading-none text-neutral-N50 pointer-events-none',
        }}
      >
        {children}
      </Text>
    </div>
  );
};
